<script setup lang="ts">
import { cn } from '~~/lib/tw-utils'
import { ToastViewport, type ToastViewportProps } from 'radix-vue'
import { computed, type HTMLAttributes } from 'vue'

const props = defineProps<
  ToastViewportProps & {
    class?: HTMLAttributes['class']
    position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' | 'top-center' | 'bottom-center'
  }
>()

const delegatedProps = computed(() => {
  const { class: _, position: __, ...delegated } = props
  return delegated
})

const positionClasses = computed(() => {
  switch (props.position) {
    case 'top-left':
      return 'top-20 left-0 pl-4'
    case 'bottom-right':
      return 'bottom-0 right-0 pb-4 pr-4'
    case 'bottom-left':
      return 'bottom-0 left-0 pb-4 pl-4'
    case 'top-center':
      return 'top-20 left-1/2 -translate-x-1/2'
    case 'bottom-center':
      return 'bottom-0 left-1/2 -translate-x-1/2 pb-4'
    case 'top-right':
    default:
      return 'top-20 right-0 pr-4'
  }
})
</script>

<template>
  <ToastViewport
    v-bind="delegatedProps"
    :class="cn('fixed z-[100] max-h-screen w-full md:max-w-sm overflow-hidden hide-scrollbar max-w-[420px]', positionClasses, props.class)"
  />
</template>
